import React from 'react'
import {Icon} from '@chakra-ui/react'

const DownloadDocumentIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M3.25 17H3.5C5.76 17 6.75 15.72 6.75 14C6.75 12.28 5.76 11 3.5 11H1V19H3.25V17ZM3 13H3.5C4.53 13 4.75 13.29 4.75 14C4.75 14.71 4.53 15 3.5 15H3V13Z"
                fill="currentColor"
            />
            <path
                d="M13.5 15C13.5 12.29 12.23 11 10.21 11H7.5V19H10.21C12.23 19 13.5 17.71 13.5 15ZM10.21 17H9.5V13H10.21C11.12 13 11.5 13.39 11.5 15C11.5 16.61 11.12 17 10.21 17Z"
                fill="currentColor"
            />
            <path d="M19.5 13V11H14.5V19H16.5V16.5H18.5V14.5H16.5V13H19.5Z" fill="currentColor" />
            <path
                d="M18.91 0H3V9H5V2H16V7H21V22H3V24H23V4.09L18.91 0ZM21 5H18V2H18.09L21 4.91V5Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default DownloadDocumentIcon
